import $ from 'jquery'
import newsteaser from './newsteaser.js'
import Awesomplete from 'awesomplete'

const $header = $('header'),
  $burgerMenuContainer = $header.find('.burger-menu-container'),
  $burgerMenu = $burgerMenuContainer.find('.burger-menu'),
  $mobileHeaderEl = $header.find('.mobile.navigation-list'),
  $mobileLanguageSelect = $header.find('.mobile.navigation-meta'),
  $mainNavigation = $header.find('.navigation-main'),
  $mainNavigationContainer = $header.find('.navigation-main .js-mobile-container'),
  $mainNavigationItem = $header.find('.navigation-main .navigation-list-item'),
  $mainNavigationItemMobile = $header.find('.mobile.navigation-list .navigation-list-item, .mobile.navigation-meta .meta-nav-item:not(.language-select)'),
  $metaFlyoutContainers = $header.find('.desktop.meta-flyout-container'),
  $mainNavigationWrapper = $header.find('.mobile-wrapper'),
  $navigationBox = $header.find('.navigation-box'),
  $navigationBoxFixed = $header.find('.sticky-box'),
  $flyout = $header.find('.flyout-container'),
  $innerFlyout = $flyout.find('.flyout'),
  $flyoutMobile = $header.find('.mobile.dropdown-navigation'),
  $scrollUpContainer = $header.find('.js-scroll-up-visible'),
  $body = $('body'),
  $html = $('html'),
  $searchButton = $header.find('.navigation .search.desktop'),
  $searchFlyout = $header.find('.search-flyout-container.desktop'),
  $searchButtonMobile = $header.find('.navigation .search.mobile'),
  $searchFlyoutMobile = $header.find('.search-flyout-container.mobile'),
  $dealerFlyout = $header.find('.dealer-flyout-container.desktop'),
  $customerFlyout = $header.find('.customer-flyout-container.desktop'),
  $fixedLogo = $header.find('.js-fixed-logo'),
  $absoluteLogo = $header.find('.js-absolute-logo'),
  $campaignNavigation = $header.find('.navigation-campaign-align-meta'),
  $anchorLinks = $header.find('a.anchor')

let offsetMemory = 0,
  topOffset = 0,
  navTimeout,
  memoryWidth = 0,
  isAnchorNavigation = false,
  flyoutCloseAnimationId = 0,
  flyoutTriggerElement = null,
  searchTriggerElement = null

function init () {
  if ($header.length) {
    if ($header.data('type') === 'anchor') {
      isAnchorNavigation = true
      setAnchorLinks($header)
    }
    twoLineArrow()
    handleMainNavigation()
    burgerMenu()
    handleMobileMenu()
    handleSearchFlyout()
    autocompleteSearch()
    handleMetaFlyout()
    calcFlyoutPosition()
    setInitWindowWith()
    anchorHandler()
    handleThirdLevel()
  }
}

function getAccordionTrigger (sibling) {
  // The trigger markup isn't always the button itself (e.g. header_menu_from_documents.ftl
  // wraps it in a .btn-box div), so resolve to the actual <button> when present.
  if (sibling.tagName === 'BUTTON') return sibling
  return sibling.querySelector('button') || sibling
}

function handleThirdLevel () {
  const accordeons = $flyout.find('.accordeon').add($flyoutMobile.find('.accordeon'))
  accordeons.each(i => {
    const accordeon = accordeons[i]
    const sibling = accordeon.previousElementSibling
    const trigger = getAccordionTrigger(sibling)
    trigger.addEventListener('click', function () {
      if (accordeon.classList.contains('opened')) {
        sibling.classList.remove('opened')
        accordeon.classList.remove('opened')
        accordeon.parentElement.classList.remove('opened')
        if (trigger.tagName === 'BUTTON') trigger.setAttribute('aria-expanded', 'false')
      } else {
        closeThirdLevelAccordeons()

        sibling.classList.add('opened')
        accordeon.classList.add('opened')
        accordeon.parentElement.classList.add('opened')
        if (trigger.tagName === 'BUTTON') trigger.setAttribute('aria-expanded', 'true')
      }
    })
  })
}

function closeThirdLevelAccordeons () {
  const accordeons = $flyout.find('.accordeon').add($flyoutMobile.find('.accordeon'))
  accordeons.each(function () {
    const sibling = this.previousElementSibling
    const trigger = getAccordionTrigger(sibling)
    this.classList.remove('opened')
    sibling.classList.remove('opened')
    this.parentElement.classList.remove('opened')
    if (trigger.tagName === 'BUTTON') trigger.setAttribute('aria-expanded', 'false')
  })
}

function setInitWindowWith () {
  memoryWidth = $(window).innerWidth()
}

function setAnchorLinks ($header) {
  const anchorMainTemplate = '<a href=\'#%id%\' class=\'navigation-list-item position-relative anchor\'>%text%</a>'
  const anchorSecTemplate = '<a href=\'#%id%\' class=\'navigation-list-item d-block position-relative anchor\'>%text%</a>'
  const mainLinkTarget = $header.find('.js-anchor-navigation-main')
  const secLinkTarget = $header.find('.js-anchor-navigation-sec')

  let anchorTargets = $('[id^="_"]')

  anchorTargets.each(function (index, element) {
    let elementId = element.id,
      elementDisplayName = element.getAttribute('data-anchor-display-name')

    mainLinkTarget.each(function (mainIndex, mainElement) {
      let processedTemplate = anchorMainTemplate.replace('%id%', elementId).replace('%text%', elementDisplayName)
      $(mainElement).append(processedTemplate)
    })
    secLinkTarget.each(function (mainIndex, secElement) {
      let processedTemplate = anchorSecTemplate.replace('%id%', elementId).replace('%text%', elementDisplayName)
      $(secElement).append(processedTemplate)
    })
  })

  $mobileHeaderEl.find('.navigation-list-item.anchor').on('click', closeMobileMenu)

  for (let target of $.fn.add.call(mainLinkTarget, secLinkTarget)) {
    for (let link of $(target).find('.navigation-list-item')) {
      let targetId = link.getAttribute('href')
      console.log('targetId', targetId)
      if (targetId.substring(0, 1) === '#') {
        $(link).on('click', function (event) {
          event.preventDefault()

          if (targetId !== null) {
            $('html, body').animate({
              scrollTop: $(targetId).offset().top - 150
            }, 1000, 'linear')
          }
        })
      }
    }
  }
}

function burgerMenu () {
  $burgerMenuContainer.on('click', function () {
    $(this).toggleClass('active')
    $burgerMenu.toggleClass('active')
    $mainNavigationItemMobile.removeClass('active').filter('button').attr('aria-expanded', 'false')
    $flyoutMobile.hide()
    if ($burgerMenu.hasClass('active')) {
      topOffset = $(document).scrollTop()
      $burgerMenuContainer.addClass('active')
      $burgerMenuContainer.attr('aria-expanded', 'true')
      $body.addClass('mobile-fix')
      $html.addClass('mobile-fix')
      $mainNavigation.addClass('mobile-open pl-0 pr-0')
      $mainNavigationWrapper.addClass('active')
      $mainNavigationContainer.addClass('container')
    } else {
      $burgerMenuContainer.removeClass('active')
      $burgerMenuContainer.attr('aria-expanded', 'false')
      $body.removeClass('mobile-fix')
      $html.removeClass('mobile-fix')
      $(document).scrollTop(topOffset)
      $mainNavigation.removeClass('mobile-open pl-0 pr-0')
      $mainNavigationWrapper.removeClass('active')
      $mainNavigationContainer.removeClass('container')
    }
  })
}

function handleMobileMenu () {
  $burgerMenuContainer.on('click', function () {
    $navigationBox.css('opacity', 1)
    $mobileHeaderEl.toggleClass('open')
    $mobileLanguageSelect.toggleClass('open')
    $burgerMenuContainer.attr('aria-expanded', $burgerMenuContainer.hasClass('active') ? 'true' : 'false')
    $flyoutMobile.removeClass('active')
    if ($searchFlyoutMobile.hasClass('open')) {
      $searchFlyoutMobile.removeClass('open')
      $searchButtonMobile.removeClass('open').attr('aria-expanded', 'false')
    }
  })
}

function trackPiwikProNavbarHeatmapClick ($element) {
  if (!window._paq) {return}

  const domElement = $element[0]
  const elementPath = getPathUntilUnique(domElement)

  window._paq.push(['trackEvent', 'Heatmap events', 'Click', elementPath])
}

function getPathUntilUnique (element) {
  if (!element || !element.parentElement) {
    return ''
  }

  if (element.id) {
    return `#${element.id}`
  }

  if (!element.parentElement.parentElement) {
    return element.tagName.toLowerCase()
  }

  const siblings = Array.from(element.parentElement.children)
  const nthChildIndexString =
    siblings.filter((sibling) => sibling.tagName === element.tagName).length > 1
      ? `:nth-child(${siblings.indexOf(element) + 1})`
      : ''

  const classNames = element.className
    .split(' ')
    .map((className) => (className ? `.${className}` : ''))
    .join('')

  const elementInfo = `${element.tagName.toLowerCase()}${nthChildIndexString}${classNames}`

  return `${getPathUntilUnique(element.parentElement)}>${elementInfo}`
}

function handleMainNavigation () {
  /* open navigation */
  $mainNavigationItem.each(function () {
    var $this = $(this),
      $mainNaviDataAttribute = $(this).attr('data-item-name')

    $this.on('click', function (ev) {
      if ($this.data('item-name')) {
        ev.preventDefault()
        ev.stopPropagation()

        //sending click on navbar to Piwik for tracking, since event won't reach it otherweise due to stopped propagation.
        trackPiwikProNavbarHeatmapClick($this)

        closeMetaFlyout()
        closeSearch()

        if ($flyout.hasClass('active') && $flyout.find('[data-item-box=\'' + $mainNaviDataAttribute + '\']').hasClass('active')) {
          closeFlyout()
        } else {
          flyoutTriggerElement = this
          flyoutCloseAnimationId++
          if ($('.item-box').hasClass('active')) {
            $('.teaser-box').removeClass('active')
            $('.item-box').removeClass('active')
            $mainNavigationItem.removeClass('active').filter('button').attr('aria-expanded', 'false')
          }
          $mainNavigationItem.removeClass('active').filter('button').attr('aria-expanded', 'false')
          $flyout.find('[data-item-box=\'' + $mainNaviDataAttribute + '\']').addClass('active')
          $flyout.find('[data-teaser-box=\'' + $mainNaviDataAttribute + '\']').addClass('active')
          $flyout.stop(true, true).slideDown('slow')
          $flyout.addClass('active')
          if ($(window).height() < ($innerFlyout.height() + ($navigationBoxFixed.is(':visible') ? $navigationBoxFixed.height() - parseInt($navigationBoxFixed.css('top')) : $navigationBox.height() + $(window).scrollTop()))) {
            $innerFlyout.addClass('flyout-scroll')
          } else {
            $innerFlyout.removeClass('flyout-scroll')
          }
          $header.find('.navigation-main .navigation-list-item[data-item-name=' + $mainNaviDataAttribute + ']').addClass('active').filter('button').attr('aria-expanded', 'true')
          newsteaser.init()
        }

        if ($searchFlyout.hasClass('open')) {
          closeSearch()
        }
      }
    })
  })

  $(window).on('resize', function () {
    twoLineArrow()

    if (memoryWidth === $(window).innerWidth()) {
      return
    } else {
      memoryWidth = $(window).innerWidth()
    }
    // 992 smaller lg
    if ($flyout.hasClass('active') && $(window).innerWidth() < 992) {
      $flyout.slideUp('slow')
      $innerFlyout.removeClass('flyout-scroll')
      $mainNavigationItem.filter('button').attr('aria-expanded', 'false')
    } else if ($burgerMenuContainer.hasClass('active') && $(window).innerWidth() >= 992) {
      $flyoutMobile.removeClass('active')
      $flyoutMobile.slideUp('slow')
      calcFlyoutPosition()
      closeMobileMenu()
    } else if ($(window).innerWidth() >= 992) {
      $burgerMenuContainer.removeClass('active')
      $burgerMenuContainer.attr('aria-expanded', 'false')
      $body.removeClass('mobile-fix')
      $html.removeClass('mobile-fix')
      $mainNavigation.removeClass('mobile-open pl-0 pr-0')
      $mainNavigationWrapper.removeClass('active')
      calcFlyoutPosition()
      if ($metaFlyoutContainers.first().data('height') === 0) {
        setMetaFlyoutHeight()
      }
    }

    if ($(window).innerWidth() < 992) {
      closeMetaFlyout()
      $('.teaser-box').removeClass('active')
      $('.item-box').removeClass('active')
      $flyout.removeClass('active')
      $innerFlyout.removeClass('flyout-scroll')
      $mainNavigationItem.removeClass('active').filter('button').attr('aria-expanded', 'false')
    }

    $searchFlyout.removeClass('open')
    $searchFlyout.slideUp('slow')
    $searchButton.removeClass('open').attr('aria-expanded', 'false')
    $searchFlyoutMobile.removeClass('open')
    $searchButtonMobile.removeClass('open').attr('aria-expanded', 'false')

    $(window).trigger('scroll')
  })

  $(document).on('click', function (ev) {
    $metaFlyoutContainers.each(function () {
      if ($(this).hasClass('open')) {
        const thisElement = $(this).get(0)
        if (thisElement && thisElement.contains(ev.target)) {
          console.log('open')
        } else {
          closeMetaFlyout()
        }
      }
    })
    if ($searchFlyout.hasClass('open')) {
      const searchFlyoutElement = $searchFlyout.get(0)
      if ((searchFlyoutElement && searchFlyoutElement.contains(ev.target)) || $searchButton.get(0) === ev.target || $searchButton.get(1) === ev.target) {
      } else {
        closeSearch()
      }
    } else {
      if (!isAnchorNavigation) {
        const flyoutEl = $flyout.get(0)
        if (flyoutEl && flyoutEl.contains(ev.target)) {
        } else {
          closeFlyout()
        }
      }
    }
  })

  /* open mobile navigation */
  $mainNavigationItemMobile.on('click', function (e) {
    if (!$(this).hasClass('language-switch') && !$(this).hasClass('directLink') && !$(this).hasClass('anchor')) {
      e.preventDefault()
      if ($(this).next('.dropdown-navigation').hasClass('active')) {
        $mainNavigationItemMobile.removeClass('active').filter('button').attr('aria-expanded', 'false')
        $flyoutMobile.removeClass('active')
        $flyoutMobile.slideUp({ duration: 'slow', easing: 'linear' })
      } else {
        $mainNavigationItemMobile.removeClass('active').filter('button').attr('aria-expanded', 'false')
        $(this).addClass('active')
        if ($(this).is('button')) $(this).attr('aria-expanded', 'true')
        $flyoutMobile.removeClass('active')
        $flyoutMobile.slideUp({ duration: 'slow', easing: 'linear' })
        $(this).next($flyoutMobile).addClass('active')
        $(this).next($flyoutMobile).slideDown({ duration: 'slow', easing: 'linear' })
      }
    }
  })

  /* close navigation */
  $flyout.find('.btn-close').on('click', function () {
    closeFlyout(true)
  })

  scrollNaviagtion()
  $(window).scroll(function () {
    scrollNaviagtion()
  })

  function scrollNaviagtion () {
    let scrollTop = $(window).scrollTop(),
      screenWidth = $(window).width()

    if (screenWidth > 992) {
      if (scrollTop > offsetMemory) {
        closeMetaFlyout()
      }
      if (scrollTop > 60) {
        $('.sticky-box').css('display', 'block')
        $absoluteLogo.css('background-position', '')
        $absoluteLogo.addClass('logo-transition')
        clearTimeout(navTimeout)
        if (scrollTop <= offsetMemory) {
          $scrollUpContainer.removeClass('navigation-retracted')
          $('.flyout-container').css({ 'top': '130px', 'position': 'fixed' })
          $searchFlyout.css({ 'top': '130px', 'position': 'fixed' })
          $fixedLogo.removeClass('closed-logo')
          $campaignNavigation.removeClass('closed')
          $customerFlyout.css({ 'top': '54px', 'transition': 'top .5s' })
          $dealerFlyout.css({ 'top': '54px', 'transition': 'top .5s' })
        } else {
          if (!$burgerMenuContainer.hasClass('active')) {
            $scrollUpContainer.addClass('navigation-retracted')
          }
          $flyout.css({ 'top': '70px', 'position': 'fixed' })
          $searchFlyout.css({ 'top': '70px', 'position': 'fixed' })
          $fixedLogo.addClass('closed-logo')
          $campaignNavigation.addClass('closed')
          $customerFlyout.css({ 'top': '9px', 'transition': 'top .5s' })
          $dealerFlyout.css({ 'top': '9px', 'transition': 'top .5s' })
          if (!$flyout.hasClass('transition')) {
            setTimeout(() => {
              $flyout.addClass('transition')
              $searchFlyout.addClass('transition')
            }, 50)
          }
        }
      } else {
        if (scrollTop <= 0) {
          $navigationBox.css('opacity', 1)
          $flyout.removeClass('transition')
          $searchFlyout.removeClass('transition')
          offsetMemory = scrollTop
          $flyout.css({ 'top': '130px', 'position': 'absolute' })
          $searchFlyout.css({ 'top': '130px', 'position': 'absolute' })
          $fixedLogo.removeClass('closed-logo')
          $campaignNavigation.removeClass('closed')
          $customerFlyout.css({ 'top': '54px', 'transition': 'top .5s' })
          $dealerFlyout.css({ 'top': '54px', 'transition': 'top .5s' })
          $scrollUpContainer.removeClass('navigation-transition')
          $scrollUpContainer.removeClass('navigation-retracted')
          setTimeout(() => {
            $scrollUpContainer.addClass('navigation-transition')
          }, 50)
          if (!$burgerMenuContainer.hasClass('active')) {
            offsetMemory = scrollTop
          }
          navTimeout = setTimeout(() => {
            $('.sticky-box').css('display', 'none')
            $navigationBox.css('opacity', 1)
          }, 200)
        }
      }
      offsetMemory = scrollTop
      if (scrollTop < 60) {
        $customerFlyout.css({ 'top': (54 - scrollTop) + 'px', 'transition': '0' })
        $dealerFlyout.css({ 'top': (54 - scrollTop) + 'px', 'transition': '0' })
        $absoluteLogo.removeClass('logo-transition')
        $absoluteLogo.css('background-position', 'left ' + ((scrollTop * 0.467) + ($(window).width() < 1280 ? 35 : 22)) + '%')
        if ($('.sticky-box').css('display') === 'block' && !$header.find('.desktop.login-dealer').hasClass('active') && !$header.find('.desktop.login-customer').hasClass('active')) {
          $navigationBox.css('opacity', 0)
        }
      }
    } else {
      $absoluteLogo.css('background-position', '')
      $absoluteLogo.addClass('logo-transition')
      if (scrollTop > 0) {
        if (!$burgerMenuContainer.hasClass('active')) {
          $('.sticky-box').css('display', 'block')
          $navigationBox.css('opacity', 0)

          if (scrollTop < offsetMemory) {
            $scrollUpContainer.removeClass('navigation-retracted')
            offsetMemory = scrollTop
            $('.flyout-container').css({ 'top': '130px', 'position': 'fixed' })
            $searchFlyout.css({ 'top': '130px', 'position': 'fixed' })
            $fixedLogo.addClass('closed-logo')
            $campaignNavigation.addClass('closed')
            $customerFlyout.css({ 'top': '54px', 'transition': 'top .5s' })
            $dealerFlyout.css({ 'top': '54px', 'transition': 'top .5s' })
          } else {
            if (!$burgerMenuContainer.hasClass('active')) {
              $scrollUpContainer.addClass('navigation-retracted')
            }
            offsetMemory = scrollTop
            $('.flyout-container').css({ 'top': '70px', 'position': 'fixed' })
            $searchFlyout.css({ 'top': '70px', 'position': 'fixed' })
            $fixedLogo.removeClass('closed-logo')
            $campaignNavigation.removeClass('closed')
            $customerFlyout.css({ 'top': '9px', 'transition': 'top .5s' })
            $dealerFlyout.css({ 'top': '9px', 'transition': 'top .5s' })
          }
        }
      } else {
        $('.sticky-box').css('display', 'none')
        $navigationBox.css('opacity', 1)
        $('.flyout-container').css({ 'top': '130px', 'position': 'absolute' })
        $searchFlyout.css({ 'top': '130px', 'position': 'absolute' })
        if (!$burgerMenuContainer.hasClass('active')) {
          $scrollUpContainer.addClass('navigation-retracted')
        }
      }
    }
    if ($flyout.hasClass('active') && $innerFlyout.scrollTop() === 0) {
      $innerFlyout.removeClass('flyout-scroll')
      if ($(window).height() < ($innerFlyout.height() + ($navigationBoxFixed.is(':visible') ? $navigationBoxFixed.height() - parseInt($navigationBoxFixed.css('top')) : $navigationBox.height() + $(window).scrollTop()))) {
        $innerFlyout.addClass('flyout-scroll')
      } else {
        $innerFlyout.removeClass('flyout-scroll')
      }
    }
  }
}

function calcFlyoutPosition () {
  let screenWidth = $(window).width(),
    maxWidth = parseInt($('header .navigation-box .container').css('maxWidth')),
    $navPoints = $header.find('.desktop.meta-nav-item')

  for (let i = $navPoints.length - 1; i >= 0; i--) {
    let $navPoint = $($navPoints[i]),
      $flyout = $navPoint.find('.meta-flyout-container')

    if ($flyout.length) {
      $flyout.css('left', $navPoint.position().left + ((screenWidth - maxWidth) / 2) - ($flyout.width() / 2) + ($navPoint.width() / 2) - 15)
    }
  }
}

function twoLineArrow () {
  let screenWidth = $(window).width(),
    item = $('.menu-item-active')
  if (item.length > 0) {
    if (screenWidth > 992) {
      if (item.height() > 30) {
        item.addClass('two-lined')
      } else {
        item.removeClass('two-lined')
      }
    }
  }
}

function closeFlyout (returnFocus) {
  closeThirdLevelAccordeons()
  const closeAnimationId = ++flyoutCloseAnimationId
  const triggerToFocus = returnFocus ? flyoutTriggerElement : null
  flyoutTriggerElement = null

  $flyout.removeClass('active')
  $mainNavigationItem.removeClass('active').filter('button').attr('aria-expanded', 'false')
  $flyout.stop(true, false).slideUp('slow', function () {
    if (closeAnimationId === flyoutCloseAnimationId && !$flyout.hasClass('active')) {
      clearFlyoutContent()
    }
    if (triggerToFocus) {
      triggerToFocus.focus()
    }
  })
}

function clearFlyoutContent () {
  $flyout.find('.item-box').removeClass('active')
  $flyout.find('.teaser-box').removeClass('active')
  $innerFlyout.removeClass('flyout-scroll')
}

function closeSearch (returnFocus) {
  const triggerToFocus = returnFocus ? searchTriggerElement : null
  searchTriggerElement = null

  $searchFlyout.animate({
    height: '0'
  }, 500, function () {
    $searchFlyout.css('height', '0')
    $searchFlyout.removeClass('open')
    $searchFlyout.css('display', '')
    $searchButton.removeClass('open').attr('aria-expanded', 'false')
    if (triggerToFocus) {
      triggerToFocus.focus()
    }
  })
}

function handleSearchFlyout () {
  $searchButton.on('click', function () {
    if ($searchFlyout.hasClass('open')) {
      closeSearch()
    } else {
      searchTriggerElement = this
      closeFlyout()
      closeMetaFlyout()
      $searchFlyout.addClass('open')
      $searchButton.addClass('open').attr('aria-expanded', 'true')
      $searchFlyout.animate({
        height: '157px'
      }, 500, function () {
        $('.search-input').focus()
      })
    }
  })

  $searchButtonMobile.on('click', function () {
    if ($searchFlyoutMobile.hasClass('open')) {
      $searchFlyoutMobile.removeClass('open')
      $searchButtonMobile.removeClass('open').attr('aria-expanded', 'false')
    } else {
      $searchFlyoutMobile.addClass('open')
      $searchButtonMobile.addClass('open').attr('aria-expanded', 'true')
      $('.search-input').focus()
    }
    closeMobileMenu()
  })

  $searchFlyout.find('.btn-close').on('click', function () {
    closeSearch(true)
  })

}

function closeMobileMenu () {
  closeThirdLevelAccordeons()
  if ($burgerMenuContainer.hasClass('active')) {
    $burgerMenuContainer.removeClass('active')
    $burgerMenuContainer.attr('aria-expanded', 'false')
    $burgerMenu.removeClass('active')
    $mainNavigationItem.removeClass('active').filter('button').attr('aria-expanded', 'false')
    $mainNavigationItemMobile.removeClass('active').filter('button').attr('aria-expanded', 'false')
    $mobileHeaderEl.removeClass('open')
    $mobileLanguageSelect.removeClass('open')
    $body.removeClass('mobile-fix')
    $html.removeClass('mobile-fix')
    $(document).scrollTop(topOffset)
    $mainNavigation.removeClass('mobile-open pl-0 pr-0')
    $mainNavigationWrapper.removeClass('active')
    $mainNavigationContainer.removeClass('container')
  }
}

function autocompleteSearch () {
  let recommendations = getAutoCompleteList()

  var inputDesktop = $('.desktop.search-flyout-container .search-input').get(0)
  var inputMobile = $('.mobile.search-flyout-container .search-input').get(0)

  //recommendations.push("test");

  if (inputDesktop != null) {
    new Awesomplete(inputDesktop, {
      list: recommendations,
      minChars: 3
    })
    new Awesomplete(inputMobile, {
      list: recommendations,
      minChars: 3
    })

    $('.search-input').attr('autocomplete', 'off')

    $('.search-form .awesomplete').on('awesomplete-open', function () {
      if (!$('.search-form  .awesomplete').find('.awesomplete-before').length) {
        $('.search-form  .awesomplete').append(
          '<div class=\'awesomplete-before\'>' + window.mainSearchRecommendations.searchResult + '</div>'
        )
      }
    })

    $('.search-form .awesomplete').on('awesomplete-close', function () {
      $('.awesomplete').find('.awesomplete-before').remove()
    })

    $('.search-form .awesomplete').on('awesomplete-select', function (event) {
      let selection = event.originalEvent.text.label,
        searchUrl = $header.find('.navigation-box').first().data('search-url')

      const referrer = window.location.href || 'none'
      const eventDetails = { query: selection, referrer: referrer }
      const searchEvent = new CustomEvent('website-search', { detail: eventDetails })
      document.dispatchEvent(searchEvent)

      window.location.href = searchUrl + '?query=' + encodeURI(selection)
    })
  }
}

function getAutoCompleteList () {
  if (window.searchRecommendationsList && window.searchRecommendationsList.length) {
    return window.searchRecommendationsList
  }

  return []
}

function setMetaFlyoutHeight () {
  $metaFlyoutContainers.each(function () {
    $(this).css('height', 'auto')
    $(this).attr('data-height', $(this).outerHeight())
    $(this).css('height', 0)
  })
}

function handleMetaFlyout () {
  setMetaFlyoutHeight()
  $('.meta-nav-item[data-meta-dropdown-id]').each(function () {
    $(this).on('click', function (ev) {
      let id = $(this).data('meta-dropdown-id')
      let flyout = $('.meta-flyout-container[data-meta-dropdown-id=' + id + ']')

      closeFlyout()
      closeSearch()
      closeMetaFlyout()

      if (!flyout.hasClass('open') && !flyout.is(':animated')) {
        flyout.addClass('open')
        flyout.css('display', '')
        flyout.animate({
          height: flyout.attr('data-height') + 'px'
        }, 500)
      }
    })
  })
}

function closeMetaFlyout () {
  closeThirdLevelAccordeons()
  $metaFlyoutContainers.each(function () {
    let flyout = $(this)
    if (flyout.hasClass('open') && !flyout.is(':animated')) {
      flyout.animate({
        height: '0'
      }, 500, function () {
        flyout.removeClass('open')
        flyout.css('height', '0')
      })
    }
  })
}

function anchorHandler () {
  $anchorLinks.on('click', (event) => {
    event.preventDefault()

    closeMobileMenu()

    let href = event.currentTarget.getAttribute('href')

    if (window.location.pathname == href.split('#')[0]) {
      let el = $(document).find(href).first()

      if (el.length > 0) {
        $('html, body').animate({
          scrollTop: el.offset().top - 150
        }, 1000, 'linear')
      }
    } else {
      window.location = href
    }
  })
}

export default {
  init
}
